import React from 'react';
import { Box, Text, Button, VStack, Heading, useColorModeValue } from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <Box
      minH="100vh"
      bg="background.page"
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={4}
    >
      <Box
        bg={cardBg}
        border="1px"
        borderColor={borderColor}
        borderRadius="lg"
        p={8}
        textAlign="center"
        maxW="400px"
        shadow="card"
      >
        <VStack spacing={6}>
          <Heading size="2xl" color="primary.700">
            404
          </Heading>
          <Heading size="lg" color="gray.800">
            Page Not Found
          </Heading>
          <Text color="gray.600">
            The page you're looking for doesn't exist or has been moved.
          </Text>
          <Button
            leftIcon={<ChevronRightIcon />}
            colorScheme="primary"
            size="lg"
            onClick={() => navigate('/')}
            className="btn-primary"
          >
            Go to Dashboard
          </Button>
        </VStack>
      </Box>
    </Box>
  );
};

export default NotFound;
